import Handlebars from "handlebars";
import { createSlug } from "./app.common.js";

const awardSearchForm = document.querySelector('#awards-search-form');
const awardSearchResult = document.querySelector('#awards-search-result-container');
const eventTileTemplateId = "event-tile-template";


const submitAwardsSearch = async () => {    
    const formData = new FormData(awardSearchForm);
    formData.delete("__RequestVerificationToken");

    for (let [key, value] of formData.entries()) {
        if (!value) {
            formData.delete(key);
        }
    }

    const searchParams = new URLSearchParams(formData).toString(); 
    window.history.pushState(null, null, `?${searchParams}`);
    const fetchResultUrl = `/api/awards?${searchParams}`;
    const csrfToken = awardSearchForm.querySelector('input[name="__RequestVerificationToken"]').value;

    var response = await fetch(fetchResultUrl, {
        method: 'GET',
        headers: {
            'RequestVerificationToken': csrfToken
        }
    });

    if (!response.ok) {
        throw new Error('Network response was not ok');
    }

    const result = await response.json();
    renderSearchResult(result);
}

const renderSearchResult = ({ data = [] }) => {
    if (data.length === 0) {
        awardSearchResult.style.display = 'block';
        awardSearchResult.innerHTML = '<h2>No awards found</h2>';
    } else {
        for (const award of data) {
            const awardNameSlug = createSlug(award.name);
            award.pageUrl = `/awards/project/${awardNameSlug}/${award.id}`;
        }

        awardSearchResult.style.display = 'grid';
        const templateSource = document.getElementById(eventTileTemplateId).innerHTML;
        const template = Handlebars.compile(templateSource);
        const htmlResults = template({ result: data });

        awardSearchResult.innerHTML = htmlResults;
    }
};

document.addEventListener('DOMContentLoaded', function () {
    if (awardSearchForm) {
        awardSearchForm.addEventListener('submit', function (event) {
            event.preventDefault();
            submitAwardsSearch();
        });

        const dropdowns = awardSearchForm.querySelectorAll('select');
        dropdowns.forEach(dropdown => {
            dropdown.addEventListener('change', function () {
                submitAwardsSearch();
            });
        });

        const searchbox = awardSearchForm.querySelector('input[type="text"]');
        searchbox.addEventListener('keypress', function (event) {
            if (event.key === 'Enter') {
                submitAwardsSearch();
            }
        });

        submitAwardsSearch();
    }
});
